(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Search', Search);

    Search.$inject = ['$http'];

    function Search($http) {

        var service = {
            query : query
        };

        return service;

        function query(q) {
            if (!angular.isString(q) || !q) {
                return;
            }
            return $http.get('api/search/' + q);
        }
    }
})();
